import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Materiel } from 'src/app/model/materiel/materiel.model';
import { MaterielService } from 'src/app/services/materiel/materiel.service';

@Component({
  selector: 'app-materiel',
  templateUrl: './materiel.component.html',
  styleUrls: ['./materiel.component.scss']
})
export class MaterielComponent implements OnInit {

  public materiel!: Materiel;
  public identifiant !: string;

  constructor(private service : MaterielService, private activatedRoute: ActivatedRoute, private router : Router) { }

  ngOnInit(): void {
    const params = this.activatedRoute.snapshot.params
    this.identifiant = params.id;
    // getMateriel
    this.service.getMateriel(this.identifiant)
      .subscribe((materiel) => {
        this.materiel = materiel;
        console.log(materiel);
      });
  }

    /**
   * Display date into human format
   */
     public convertDate( date : string ) : string {

      let newDate = Date.parse( date );
      let correctDate = new Date( newDate );
      let result = correctDate.toLocaleString('fr-FR');
      return result;
      
    }

}
